import React from 'react'
import CircleHome from './CircleHome'
import CircleHomeHref from './CircleHomeHref'
import iconBoat from '../resourses/distancia.svg'
import iconG from '../resourses/normas.svg'
import iconMion from '../resourses/camiones.svg'
import iconCall from '../resourses/consultas.svg'
import iconBuilding from '../resourses/costos.svg'
import iconUbication from '../resourses/zona.svg'
import { Col, Container, Row } from 'react-bootstrap'

const CardAnimatedHome = () => {
    const CardContainerStyle = {
        padding: "0px",
        marginTop: "1rem",
        marginBottom: "2rem"
    }
    
    const cardHomeStyle = {
        display: "inline-block",
        width: "100%"
    }
    

    return (
        <div className="hero-icons-row" id="container-card-home" style={CardContainerStyle}>
            <Container>
                <Row>
                    <Col className="ps-4 ps-lg-5">
                        <div className="hero-icons-inner text-left p-0" style={cardHomeStyle}>
                            <div className="d-flex" style={{ justifyContent: "flex-start", flexWrap: "wrap", gap: "60px", marginTop: "10px" }}>
                                <CircleHome link="/distancia-entre-puertos" img={iconBoat} text={"Distancia<br/> entre puertos"} />
                                <CircleHome link="/zona-de-servicios" img={iconUbication} text={"Zona de<br/> servicios"} />
                                <CircleHome link="/tipo-de-camiones" img={iconMion} text={"Tipo de<br/> camiones"} />
                                <CircleHomeHref link="https://www.cac.bcr.com.ar/es/arbitraje-y-calidad/liquidacion-y-mermas/liquidacion-de-mercaderia-0" img={iconCall} text={"Consultas sobre <br/> calidades y mermas"} target={"_blank"}/>
                                <CircleHome link="/servicio-de-acondicionamiento" img={iconBuilding} text={"Costo de servicios <br/> de acondicionamiento"} />
                                <CircleHomeHref link="https://www.cac.bcr.com.ar/es/arbitraje-y-calidad/normas-de-comercializacion" img={iconG} text={"Normas de<br/> comercialización"} target={"_blank"}/>  
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default CardAnimatedHome